import { Select } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';
import type { AccountLengthOption } from '@/store/userPreferences/state.ts';

const AccountNameLength = () => {
  const { formatMessage } = useIntl();
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = ({ value }: { AccountNameLength: string; value: string }): void => {
    sgwtWebAnalytics?.trackEvent('Header', 'user preferences, general tab, account name length', value);
    updateUserPreferences({ ...userPreferences, accountNameLength: value as AccountLengthOption });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="account-name-length">
        <FormattedMessage id="userPreferences.label.accountNameLength" />
      </label>
      <Select
        id="account-name-length"
        itemValue={(item) => item.value}
        selectedItemValue={userPreferences.accountNameLength}
        itemsAsObjects={[
          { AccountNameLength: formatMessage({ id: 'userPreferences.label.account.legal' }), value: 'Legal' },
          { AccountNameLength: formatMessage({ id: 'userPreferences.label.account.short' }), value: 'Short' },
        ]}
        itemToString={({ AccountNameLength }) => AccountNameLength}
        onChange={handleChange}
        className="w-auto"
      />
    </div>
  );
};

export default AccountNameLength;
